import React from 'react'
import s from './index.module.scss'
import Header from '../../Header'
import { Outlet } from 'react-router-dom'

const AuthLayout = () => {
	return (
		<>
			<Header />

			<div className={s.wrapper}>
				<Outlet />
			</div>
		</>
	)
}

export default AuthLayout
